export const API_PREFIX = 'api';
export const API_VERSION = '1';
export const API_BASE_PATH = `/${API_PREFIX}/v${API_VERSION}`;
export const REQUEST_ID_HEADER = 'x-request-id';
//# sourceMappingURL=api-version.js.map